<template>
  <div class="top-nav">
    <nav class="navbar navbar-expand-md navbar-light navbar-laravel shadow-lg">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <!-- Sidebar Toggle (Topbar) -->
      <button
        id="sidebarToggleTop"
        class="navbar-toggler"
      >
        <img :src="appLogo">
      </button>

      <div
        class="collapse navbar-collapse"
        id="navbarCollapse"
      >
        <ul
          class="navbar-nav mr-lg-auto"
          id="navList"
        >
          <li
            class="navbar-item"
            style="text-align: left;"
          >
            <a
              class="navbar-brand"
              href=""
              style="text-align: left;"
            >
              <img :src="appLogo">
              <small
                style="padding-left: 1em;"
                class="font-weight-bold"
              >VERITAS TRAINING MANAGEMENT
                SYSTEM
              </small>
            </a>
          </li>
        </ul>

        <ul class=" navbar-nav ml-auto">
          <!-- <li class="navbar-item dropdown">
                        <ul class="nav justify-content-center">
                            <ul class="nav nav-pills">
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <h5>
                                            <i class="fas fa-bell"></i><sup>(4)</sup>
                                        </h5>
                                    </a>
                                </li>
                            </ul>
                        </ul>
                    </li>-->

          <li class="navbar-item dropdown">
            <ul class="nav justify-content-center">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                  />
                </li>
              </ul>
            </ul>
          </li>

          <li class="navbar-item dropdown">
            <ul class="nav justify-content-center">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                  />
                </li>
              </ul>
            </ul>
          </li>

          <li class="navbar-item dropdown">
            <ul class="nav justify-content-center">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/notifications"
                    tag="a"
                    href="#"
                    v-if="totalNotifications > 0"
                  >
                    <span class="float-right jewel-exp">{{ totalNotifications }}</span>
                    <h5 class="fas fa-plus-circle">
                      <small class="font-weight-bold text-dark">Notifications</small>
                    </h5>
                  </router-link>

                  <router-link
                    class="nav-link"
                    to="/notifications"
                    tag="a"
                    href="#"
                    v-else
                  >
                    <h5 class="fas fa-bell">
                      <small />
                    </h5>
                  </router-link>
                </li>
              </ul>
            </ul>
          </li>

          <hr>

          <!-- log out -->
          <li
            class="nav-item dropdown"
            style="text-align:  right;"
          >
            <a
              id="navbarDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              v-if="!!userLogin"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-user-shield" />
              <span class="caret font-weight-bold">
                {{ userLogin.last_name }}&nbsp;
                {{ userLogin.name }}&nbsp;
                {{ userLogin.middle_name }}
              </span>
              <br>
              <span class="font-weight-bold">
                {{ getUserRole }}
                <!--                                {{ userLogin.user_type ?userLogin.user_type.name : '' }}-->
              </span>
            </a>

            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbarDropdown"
            >
              <router-link
                :to="{name: 'trainingEndorsementIndex'}"
                tag="a"
                class="dropdown-item"
                href="#"
              >
                <i class="fas fa-calendar-plus" />
                Training Endorsements
              </router-link>

              <router-link
                to="/staffProfile"
                tag="a"
                class="dropdown-item"
                href="#"
              >
                <i class="fas fa-user-shield" />
                Profile
              </router-link>

              <a
                class="dropdown-item"
                href="#"
                @click="logout"
              >
                <i class="fas fa-sign-out-alt" />
                Logout
              </a>

              <form
                id="logout-form"
                action=""
                style="display: none;"
              />
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
    import imglogo from '../../assets/veritas_logo.jpeg';
    import { AuthServiceStaff } from '../../service/auth.service';
    import { gateMixins } from "../../mixins/gateMixins";
    import {mapGetters, mapActions} from 'vuex';

    export default {
        mixins: [ gateMixins ],
        name: 'TopNavigation',
        data() {
            return {
                appLogo: imglogo,
                data: [],
            };
        },

        methods: {
            ...mapActions(['setLoading', 'logoutUser', 'getUserDetails', 'refreshNotifications', 'turnoverInterval']),
            logout() {
                this.logoutUser();
                this.$router.push({ name: 'login' });
            },
        },

        computed: {
            ...mapGetters(['userLogin', 'totalNotifications']),

            getUserRole() {
                return this.userLogin.positions
                    .map(position => position.short_name )
                    .join('/');
            }
        },

        created() {
            this.getUserDetails();
            if(this.isVpTraining || this.isScheduler) {
                this.refreshNotifications(this.isVpTraining);
                let notificationInterval = setInterval(() => {
                    this.refreshNotifications(this.isVpTraining);
                }, 60000); // check notification every minute
                this.turnoverInterval(notificationInterval);
            }
        },
    };
</script>

<style scoped>

</style>
